import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrendingUp, FiTarget } = FiIcons;

const FundraisingPhases = () => {
  const phases = [
    {
      phase: "A",
      lever: "Credibility & awareness",
      assets: "Doc + Promo + Reels",
      rationale: "Emotional storytelling opens major-gift doors and seeds social buzz"
    },
    {
      phase: "B",
      lever: "Reach & social proof",
      assets: "Burst #1 + Webinar",
      rationale: "Ads drive new mid-tier prospects; live Q&A builds transparency"
    },
    {
      phase: "C",
      lever: "High-touch cultivation",
      assets: "Dinner branding + bespoke reels",
      rationale: "Polished environment and bespoke content make $600k+ asks feel justified"
    },
    {
      phase: "D",
      lever: "Wide community & matching",
      assets: "Gala hybrid + Retargeting",
      rationale: "Live show maximises pledges; ads remind warm audiences"
    },
    {
      phase: "E",
      lever: "Close-out urgency",
      assets: "Impact montage + PDF report",
      rationale: "Visual proof of progress turns soft pledges into cash-in and sets stage for Phase 2"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <SafeIcon icon={FiTrendingUp} className="w-12 h-12 mx-auto text-[#FF5F1F] mb-4" />
          <h2 className="text-3xl font-bold text-black mb-4">
            How Creatica's work lifts each fundraising phase 
            <SafeIcon icon={FiTarget} className="w-8 h-8 inline ml-2 text-yellow-500" />
          </h2>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-black text-white">
                <tr>
                  <th className="px-6 py-4 text-left font-semibold">Phase</th>
                  <th className="px-6 py-4 text-left font-semibold">Key Revenue Lever</th>
                  <th className="px-6 py-4 text-left font-semibold">Creatica Asset(s)</th>
                  <th className="px-6 py-4 text-left font-semibold">Rationale</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {phases.map((phase, index) => (
                  <tr key={phase.phase} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4">
                      <span className="bg-[#FF5F1F] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">
                        {phase.phase}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-900 font-medium">{phase.lever}</td>
                    <td className="px-6 py-4 text-gray-700">{phase.assets}</td>
                    <td className="px-6 py-4 text-gray-700">{phase.rationale}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FundraisingPhases;